import { Outlet } from 'react-router-dom';
import { ToastProvider } from '../components';
import { DataProvider } from './DataProvider';
import { SessionProvider } from './Session';
import { ThemeProvider } from './ThemeProvider';
import { Header } from './Header';
import { Nav } from './Nav';
import { TabBar } from './TabBar';
import { InstallCoach } from './InstallCoach';
import { USING_MOCK } from '../lib/api';
import './shell.css';

/**
 * The frame every screen renders inside. Providers are ordered so that theme
 * resolves before anything paints, data before the session is read, and the
 * toast host wraps everything that might need to speak.
 */
export function AppShell() {
  return (
    <ThemeProvider>
      <DataProvider>
        <SessionProvider>
          <ToastProvider>
            <a href="#main" className="sr-only">Skip to content</a>
            <div className="sh">
              <Nav />
              <div className="sh-main">
                <Header />
                {USING_MOCK && (
                  <div className="sh-mockbar no-print" role="status">
                    <span className="k-dot k-dot--stale" />
                    Mock data — the API is not connected yet. Figures are realistic, not real.
                  </div>
                )}
                <main id="main" className="sh-content">
                  <Outlet />
                </main>
              </div>
              <TabBar />
              <InstallCoach />
            </div>
          </ToastProvider>
        </SessionProvider>
      </DataProvider>
    </ThemeProvider>
  );
}
